import introJs from 'intro.js'

do ->
  'use strict'

  # ANGULAR CONTROLLER FUNCTION
  TourGeralAberturaProcessoController = (currentUserId, localStorageService, $timeout, $compile, $scope) ->
    vm = @

    # CONSTANTS

    # VARIABLES VIEW MODEL
    vm.introJs             = null
    vm.currentLocalStorage = {
      prefix: 'TourGeral.',
      suffix: "AberturaProcesso_#{currentUserId}",
      name: () -> "#{vm.currentLocalStorage.prefix}#{vm.currentLocalStorage.suffix}",
      value: () -> localStorageService.get(vm.currentLocalStorage.suffix),
      setValue: (bool) -> localStorageService.set(vm.currentLocalStorage.suffix, bool)
      init: () -> localStorageService.setPrefix(vm.currentLocalStorage.prefix)
    }

    # VARIAVEIS PRIVATE

    # WATCHES

    # INIT SETUP
    init = () =>
      initSetup()

      return

    # METHODS PRIVATE

    initSetup = ->
      vm.introJs = introJs()
      vm.currentLocalStorage.init()
      # $timeout((-> initIntroJsTourGeral()), 500)

      return

    initIntroJsTourGeral = ->
      if vm.currentLocalStorage.value() != false
        setOptionsIntroJs()
        setCallbacksIntroJs()
        setStepsTourGeralIntroJs()
        setLocalStorageIntroJs(true)
        setStartIntroJs()

      return


    setOptionsIntroJs = ->
      vm.introJs = introJs() unless vm.introJs
      vm.introJs.setOptions({doneLabel: 'Fechar', prevLabel: 'Voltar', nextLabel: 'Próximo', skipLabel: 'Pular'})

      return

    setCallbacksIntroJs = ->
      vm.introJs.onchange ->
        $timeout((->
          div_intro_html = $('.nao-ver-mais-intro')
          div_intro_html.html($compile(div_intro_html.html())($scope))
        ), 500)

      vm.introJs.onexit ->
        vm.introJs = null
        $('.toggle-sticky-top').addClass('sticky-top')

      return

    setLocalStorageIntroJs = (bool = true) ->
      if vm.currentLocalStorage.value() == null
        vm.currentLocalStorage.setValue(true)
      else if vm.currentLocalStorage.value()
        vm.currentLocalStorage.setValue(bool)

      return

    setStartIntroJs = (skipLocalStorage = false) ->
      if skipLocalStorage || vm.currentLocalStorage.value()
        vm.introJs.start()
        $('.toggle-sticky-top').removeClass('sticky-top')

      return

    setStepsTourGeralIntroJs = (showLinkCancel = true) ->
      link_cancel = (showLinkCancel && "<span class='nao-ver-mais-intro'><small>(<a class='btn-link' ng-click='tgapCtrl.naoMostrarMaisTour()'><strong class='text-danger'>CLIQUE AQUI</strong></a> para <strong class='text-warning'>NÃO MOSTRAR</strong> o tour novamente)</small></span>") || ""
      steps = [
        {
          intro: """
            <div class='text-center'>
              <div class='lead'>Olá, essa é sua tela de Abertura de Processo, vamos conhecê-la um pouco.</div>
              #{link_cancel}
            </div>
          """
        },
        {
          element:  '#step-form-passos',
          position: 'right',
          intro:    """
            <div class='text-center'>
              <div class='lead'>Aqui são listados os passos do formulário para abrir um processo.</div>
              #{link_cancel}
            </div>
          """
        },
        {
          element:  '#step-form-corpo',
          position: 'left',
          intro:    """
            <div class='text-center'>
              <div class='lead'>O formulário deve ser preenchido para Abrir um Processo.</div>
              #{link_cancel}
            </div>
          """
        },
        {
          element:  '#step-form-tipo-assunto',
          position: 'left',
          intro:    """
            <div class='text-center'>
              <div class='lead'>Tipo e Assunto de Processo devem ser preenchidos no formulário de Abertura.</div>
              #{link_cancel}
            </div>
          """
        },
        {
          element:  '#step-form-orgao-envio',
          position: 'left',
          intro:    """
            <div class='text-center'>
              <div class='lead'>Órgão de Abertura do Processo para onde o Processo será enviado após sua Abertura.</div>
              #{link_cancel}
            </div>
          """
        },
        {
          element:  '#step-form-desc',
          position: 'left',
          intro:    """
            <div class='text-center'>
              <div class='lead'>Descrição sobre o que se trata o Processo.</div>
              #{link_cancel}
            </div>
          """
        },
        {
          element:  '#step-form-documentos',
          position: 'left',
          intro:    """
            <div class='text-center'>
              <div class='lead'>Local para anexar Documentos ao Processo.</div>
              #{link_cancel}
            </div>
          """
        },
        {
          element: '#step-form-acao',
          intro:   """
            <div class='text-center'>
              <div class='lead'>Ação para Abrir um Processo.</div>
              #{link_cancel}
            </div>
          """
        },
        {
          element: '#step-form-outras-acao',
          intro:   """
            <div class='text-center'>
              <div class='lead'>Outras ações.</div>
              #{link_cancel}
            </div>
          """
        },
        {
          intro: """
            <div class='text-center'>
              <div class='lead'>Pronto, agora você está apto a Criar um Processo.</div>
              #{link_cancel}
            </div>
          """
        }
      ]
      vm.introJs.setOptions({steps})

      return


    # METHODS VIEW MODEL
    vm.naoMostrarMaisTour = () ->
      setLocalStorageIntroJs(false)
      vm.introJs.exit()

      return


    vm.showTourGeral = () ->
      setOptionsIntroJs()
      setStepsTourGeralIntroJs(false)
      setStartIntroJs(true)

      return

    # CALL INIT SETUP
    init()

    return


  # ANGULAR CONTROLLER
  angular.module('mainApp').controller 'TourGeralAberturaProcessoController', TourGeralAberturaProcessoController

  # ANGULAR INJECT DEPENDENCIES
  TourGeralAberturaProcessoController.$inject = ['currentUserId', 'localStorageService', '$timeout', '$compile',
    '$scope']

  # END BLOCK SCRIPT
  return
